import React from 'react';
import { Dialog, DialogActions, DialogContent, Button } from '@mui/material';
import { DocumentOverview } from '../../Document/DocumentOverview';
import { ILegalRequirement } from '../../Interfaces/ILegalRequirement';
import { IDocument } from '../../Interfaces/IDocument';
import { IDocumentDownloaded } from '../../Interfaces/IDocumentDownloaded';

interface IProps {
  open: boolean;
  onClose: () => void;
  title: string;
  titleVariant?: 'h4' | 'h5' | 'h6' | 'subtitle1';
  allowUpload: boolean;
  allowRemove: boolean;
  documentArray: IDocument[];
  setDocumentArray: React.Dispatch<React.SetStateAction<IDocument[]>>;
  downloadedArray?: IDocumentDownloaded[];
  legalRequirementObject: ILegalRequirement;
  handleSave: () => void;
  isStandarddocument?: boolean;
  isSendEmailPossible?: boolean;
}

export const LegalRequirementDocumentDialog: React.FC<IProps> = ({
  open,
  onClose,
  title,
  titleVariant = 'h6',
  allowUpload,
  allowRemove,
  documentArray,
  setDocumentArray,
  downloadedArray,
  legalRequirementObject,
  handleSave,
  isStandarddocument,
  isSendEmailPossible,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
      <DialogContent>
        <DocumentOverview
          key={`DocumentOverview-${title}`}
          documentArray={documentArray}
          setDocumentArray={setDocumentArray}
          allowRemove={allowRemove}
          allowUpload={allowUpload}
          name={legalRequirementObject.LegalRequirement}
          title={title}
          titleVariant={titleVariant}
          downloadedArray={downloadedArray}
          isStandarddocument={isStandarddocument}
          isSendEmailPossible={isSendEmailPossible}
        />
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          Abbruch
        </Button>
        <Button variant='contained' onClick={handleSave}>
          Übernehmen
        </Button>
      </DialogActions>
    </Dialog>
  );
};
